export default {
  addCategory: 'Ajouter une catégorie',
	addDocument: 'Ajouter une ressource',
	addSubCategory: 'Ajouter une sous-catégorie',
	index: 'Documents et ressources',
}